import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        planningGroup: '='
    },
    template: `
        <div>
             <courses-courses-edit-occurrence-automated-planning-group-steps-employee
                planning-group="vm.planningGroup"
                context="'edit'"
            />
        </div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/automated/planningGroup/edit/employee/index.js